import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { RenewalGate } from "./SubscriptionUI";

export default function ProtectedRoute({ children }) {
  const { user, loading, expiredBilling } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-nardo-50">
        <div className="text-nardo-500 uppercase tracking-[0.3em] text-xs">Cargando…</div>
      </div>
    );
  }
  if (!user && expiredBilling) return <RenewalGate billing={expiredBilling} />;
  if (!user) return <Navigate to="/" replace state={{ from: location }} />;
  return children;
}
